import { DAYS_OF_WEEK_LOWERCASE_LENGTH_3 } from "constants/daysOfWeek";
import moment, { MomentInput } from "moment-timezone";
import { getRepeatEndByType } from "./getRepeatEndByType";

const DEFAULT_REPEAT_RULE: Pick<
  RepeatRule,
  "repeat_every" | "repeat_interval" | "repeat_on_days"
> = {
  repeat_every: 1,
  repeat_interval: "week",
  // TODO: should be default to current day?
  repeat_on_days: [],
};

/**
 * get default repeat rule by start and timezone
 */
export const getDefaultRepeatRule = ({
  intervalStart,
  timezone,
}: {
  intervalStart: MomentInput;
  timezone: string;
}) => {
  // get day of week
  const weekday = moment.tz(intervalStart, timezone).day();
  return {
    ...DEFAULT_REPEAT_RULE,
    repeat_end: getRepeatEndByType({
      intervalStart,
      timezone,
      type: "end_date",
      repeat_every: DEFAULT_REPEAT_RULE.repeat_every,
      repeat_interval: DEFAULT_REPEAT_RULE.repeat_interval,
    }),
    repeat_on_days: [DAYS_OF_WEEK_LOWERCASE_LENGTH_3[weekday]],
  };
};
